import React from 'react';
import { categoryFilter } from '../../store/actions';
import { useSelector, useDispatch } from 'react-redux';
import { ProductCategory } from '../../types/product/product';
import { Select } from 'components/atoms/Inputs/Select';
import { DialogContent } from 'components/molecules/Modal/DialogContent';
import { AppState } from '../../store/reducers';

interface SelectCatProduitsViewProps {
  categories: Array<ProductCategory>;
}

const SelectCatProduitsView = ({ categories }: SelectCatProduitsViewProps) => {
  const categorie = useSelector(
    (state: AppState) => state.productFilter.category
  );
  const dispatch = useDispatch();

  return (
    <DialogContent dialogTitle="Filtrer par famille">
      <Select
        onChange={value => dispatch(categoryFilter(value))}
        value={categorie || ''}
        initialOptionName={'Toutes les familles'}
        initialOptionValue={'0'}
        productsOptions={categories}
      />
    </DialogContent>
  );
};
export default SelectCatProduitsView;
